import React, { useRef, useState } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import { Tab } from './CustomizedFundList';

interface TabsProps {
    tabs: Tab[];
    hideTabs: boolean;
    isSticky: boolean;
    selected: string;
    data: any;
    onChange: (id: string) => void;
}

const Tabs = (props: TabsProps) => {
    const { tabs, hideTabs, selected, data, onChange, isSticky } = props;
    const slider = useRef<HTMLDivElement>(null);
    const [scrollOffset, setScrollOffset] = useState(0);

    const handleChange = (id: string) => {
        onChange(id);
    };

    const handleOnKeyPress = (e: React.KeyboardEvent<HTMLElement>, id: string) => {
        if (e.key === 'Enter') {
            props.onChange(id);
        }
    };

    const i18n = commonHooks.useLocalization();

    const onLeftArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        scroll(0);
    };

    const onRightArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        scroll(1000);
    };

    const scroll = (scrollOffset: number) => {
        if (!slider || !slider.current) {
            return;
        }

        slider.current.scrollTo(scrollOffset, 0);
        setScrollOffset(scrollOffset);
    };

    return (
        <>
            {!hideTabs
                ? tabs &&
                  tabs?.length > 1 && (
                      <div
                          className={`tabs-wrapper ${
                              isSticky ? 'sticky-header tabs-wrapper-sticky' : ''
                          }`}
                          ref={slider}
                          role="tablist"
                      >
                          <div
                              className={`tabs-arrow-container left ${
                                  scrollOffset > 0 ? 'show' : ''
                              }`}
                              onClick={onLeftArrowClick}
                          >
                              <div className="arrow left" />
                          </div>

                          {tabs?.map((tab: Tab) => (
                              <div
                                  className={`tab ${selected === tab?.id ? 'tab-selected' : ''}`}
                                  key={tab?.id}
                                  tabIndex={0}
                                  role={'tab'}
                                  aria-selected={selected === tab?.id}
                                  onClick={() => tab?.id && handleChange(tab?.id)}
                                  onKeyDown={(e) => tab?.id && handleOnKeyPress(e, tab?.id)}
                              >
                                  {i18n.format(tab?.name, data)}
                              </div>
                          ))}

                          <div className="tabs-arrow-container right" onClick={onRightArrowClick}>
                              <div className="arrow right" />
                          </div>
                      </div>
                  )
                : null}
        </>
    );
};

export default Tabs;
